import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    BreadcrumbHome:{
        k: "breadcrumb-home",
        v: "Home"
    }
});


// WEBPACK FOOTER //
// ./src/panels/programTrackProducts/ProgramTrackProducts.labels.ts